module.exports = __webpack_public_path__ + "static/media/cn.347824ed.svg";